<template>
  <div class="container bg-light my-3 py-3 px-4">

    <div class="row">
      <div class="col-12">
        <h2 class="ms-4 text-start">Edit site</h2>
        <hr>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12 col-lg-6">
        <ca-smtt-input 
          type="text"
          label="Enter site name"
          placeholder="Site Name"
          :initialValue="siteInfo.site"
          @input="(e) => this.siteInfo.site = e.target.value"
        />
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12 col-lg-6">
        <ca-smtt-input 
          type="text"
          label="Enter site icon"
          placeholder="Site Icon"
          :initialValue="siteInfo.site_icon"
          @input="(e) => this.siteInfo.site_icon = e.target.value"
        />
        <a 
          href="https://api.flutter.dev/flutter/material/Icons-class.html"
          target="blank"
          class="btn btn-sm btn-link mt-0 py-0"
        >
          See the icons reference here
        </a>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12 col-lg-6">
        <ca-smtt-input 
          type="text"
          label="Enter site color"
          placeholder="Site Color"
          :initialValue="siteInfo.site_color"
          @input="handleColorInput"
        />
        <span 
          style="font-size: .8rem" 
          class="text-muted mx-2"
        >
          e.g. 0xFF4c505b, 0xFF000000, 0xFF4a505b
        </span>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12 col-lg-6">
        <ca-smtt-input 
          type="text"
          label="Enter site description"
          placeholder="Site Description"
          :initialValue="siteInfo.site_text"
          @input="(e) => this.siteInfo.site_text = e.target.value"
        />
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12 col-lg-6">
        <ca-smtt-input 
          type="text"
          label="Enter token url"
          placeholder="Token url"
          :initialValue="siteInfo.token_url"
          @input="(e) => this.siteInfo.token_url = e.target.value"
        />
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12 col-lg-6">
        <ca-smtt-input 
          type="text"
          label="Enter site url"
          placeholder="Site url"
          :initialValue="siteInfo.web_url"
          @input="(e) => this.siteInfo.web_url = e.target.value"
        />
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12 col-lg-6">
        <ca-smtt-input 
          type="text"
          label="Enter site order"
          placeholder="Site order"
          :initialValue="siteInfo.order"
          @input="(e) => this.siteInfo.order = e.target.value"
        />
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12 col-lg-6">
        <ca-smtt-multiselect 
          ref="sites"
          :initialValue="initialSiteTypes"
          placeholderToTag="Add"
          placeholder="Site types"
          name="name"
          label="Grant this user permision to smartmatic services"
          :multipleSelection="false"
          :closeOnSelect="true"
          :optionsToSelect="sitesToAdd"
          @handleAddTagging="addTag"
        />
      </div>
    </div>

    <div class="row my-4">
      <div class="col-6 col-lg-3">
        <button class="btn btn-outline-primary w-100" @click="goBack">
          Dismiss
        </button>
      </div>
      <div class="col-6 col-lg-3">
        <button 
          :disabled="disableEditButton"
          class="btn btn-primary w-100" 
          @click="handleEditSite"
        >
          Edit
        </button>
      </div>
    </div>

  </div>
</template>
<script>
import caSmttInput from '../../components/ca-smtt-input.vue'
import CaSmttMultiselect from '../../components/ca-smtt-multiselect.vue'
import { getAllSiteTypes, getSiteTypeById } from '../../services/sitesTypes/sites_types.api'
import { getSiteById, updateSite } from '../../services/sites/site.api'

export default {
  data() {
    return {
      siteInfo: {
        site: null,
        typeSiteId: null,
        site_icon: null,
        site_color: null,
        site_text: null,
        web_url: null,
        token_url: null,
        order: null
      },
      disableEditButton: false,
      initialSiteTypes: [],
      sitesToAdd: [],
    }
  },
  async mounted() {
    await this.getSiteTypes()
    await this.getThisSiteData()
  },
  components: { caSmttInput, CaSmttMultiselect },
  computed: {
    siteId() { return this.$route.params.id }
  },
  methods: {
    handleColorInput(e) {
      this.siteInfo.site_color = e.target.value
      if (
        !(this.siteInfo.site_color.toLowerCase().startsWith("0xff"))
      ) return this.disableEditButton = true
      this.disableEditButton = false
    },
    async getThisSiteData() {
      try {
        // site data
        const { data: site } = await getSiteById(this.siteId)
        this.siteInfo.site = site.site.site
        this.siteInfo.typeSiteId = site.site.typeSiteId ? site.site.typeSiteId : null 
        this.siteInfo.site_icon = site.site.site_icon
        this.siteInfo.site_color = site.site.site_color
        this.siteInfo.site_text = site.site.site_text
        this.siteInfo.token_url = site.site.token_url
        this.siteInfo.web_url = site.site.web_url
        this.siteInfo.order = site.site.order

        // site type
        if (site.site.typeSiteId) {
          const { data: typeSite } = await getSiteTypeById(site.site.typeSiteId)
          this.initialSiteTypes = { name: typeSite.typeSite.type, code: site.site.typeSiteId }
        }
      } catch (error) {
        console.log(error)
      }
    },
    async getSiteTypes() {
      try {
        const { data } = await getAllSiteTypes()
        this.sitesToAdd = data.typeSites.map(site => {
          const splitted = site.type.split('_')
          let capitalizeEach = []
          for (const word of splitted) {
            capitalizeEach.push(word[0].toUpperCase() + word.slice(1))
          }
          const siteType = capitalizeEach.join(' ')
          return {code: site.id, name: siteType}
        })
      } catch (error) {
        console.log(error)
      }
    },
    addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.sitesToAdd.push(tag)
      this.initialSiteTypes.push(tag)
    },
    goBack() {
      this.$router.back()
    },
    async handleEditSite() {
      this.siteInfo.typeSiteId = this.$refs['sites'].value ? this.$refs['sites'].value.code : null
      
      try {
        await updateSite(this.siteId, this.siteInfo)
        this.$toast.open({
          message: 'Site updated successfully',
          type: 'success'
        })
        this.$router.back()
      } catch (error) {
        console.log(error)
        this.$toast.open({
          message: 'An error occurred',
          type: 'error'
        })
      }
    },
  },
}
</script>